import {environment}  from '../../src/env/environment'
import axios from 'axios'
import authHeader from '../Services/auth-header'
export const baseURL = `${environment.baseURL}/api/v1`
export const axiosInstance = axios.create({ baseURL })
export const userLogin = () => environment.baseURL + '/api/v1/user/checkMfaStatus'
export const userMfaQrValidate = () => environment.baseURL + '/api/v1/user/validateQrTokenForMfa'
export const userValidateMFAOtp = () => environment.baseURL + '/api/v1/user/validateMFAOtp'

export const userLoginAlternateMfa = () => environment.baseURL + '/api/v1/user/AlternateMfa'
export const userLoginValidateAlternateMfaOtp = () => environment.baseURL + '/api/v1/user/ValidateAlternateMfaOtp'

axiosInstance.interceptors.request.use(
    async (config) => {
        let token = authHeader()
        if (token) {
            config.headers.Authorization = token.Authorization
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)
// Add a 401 response interceptor
axiosInstance.interceptors.response.use(
    function (response) {
        return response
    },
    function (error) {
        if (error) {
            if (error.response && error.response.status === 401) {
                setTimeout(() => {
                    localStorage?.clear()
                    window.location = '/'
                    localStorage.setItem('authError', JSON.stringify('Your login session has timed out. Please log in again to continue.'))
                }, 1500)
                return Promise.reject(error.response.data.errors)
            }
            if (error.response && error.response.status === 404 && error.code !== 'ERR_NETWORK') {
                error.message = 'Server is offline. Please try again later.'
            }
            return Promise.reject(error)
        }
    }
)

//

// User Account /Details Api
export const UserAccount = async (params) => {
    const response = await axiosInstance.get(`${baseURL}/user/account/${params}`)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const logOutUser = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/user/logOut`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const loginUser = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/user/logOut`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

// Add Role /user/role/add
export const AddUserRole = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/user/role/add`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

// User Role And Permission /user/role/list/billing

export const UserRoleList = async (params) => {
    const response = await axiosInstance.get(`${baseURL}/user/role/list`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

// useroleDetails
export const getUserRoleDetails = async (params) => {
    const response = await axiosInstance.get(`${baseURL}/user/role/${params}`)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

// Update User Role /user/role/update

export const UpdateUserRole = async (params) => {
    const response = await axiosInstance.put(`${baseURL}/user/role/update`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const superAdminChangePassword = async (params) => {
    const response = await axiosInstance.put(`${baseURL}/user/change_password`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
export const forgotPassword = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/user/forgotPassword`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const registerNewDeviceMFA = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/user/registerNewDeviceMFA`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
// Check Link Expiry

export const CheckLinkExpiry = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/user/checkLinkExpiry`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const resetPassword = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/user/reset_forgot_password`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const getSuperAdminProfile = async (params) => {
    const response = await axiosInstance.get(`${baseURL}/user/${params}`)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const superAdminProfileUpdate = async (params) => {
    const response = await axiosInstance.put(`${baseURL}/user/update`, params)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const uploadMedia = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/upload_media`, params)
    if (response.data.status_code !== 200) {
        // console.log(new Error(), "jjjjjjjj")
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const uploadMultipleMedia = async (params) => {
    const response = await axiosInstance.post(`${baseURL}/uploadMultipleImage`, params)
    if (response.data.status_code !== 200) {
        // console.log(new Error(), "jjjjjjjj")
        throw new Error(response.data.errors.message)
    }
    return response.data
}

export const getRole = async (params) => {
    const response = await axiosInstance.get(params ? `${baseURL}/user/role/list/${params}` : `${baseURL}/user/role/list`)
    if (response.data.status_code !== 200) {
        throw new Error(response.data.errors.message)
    }
    return response.data
}
